export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
			value: '',
			is_title: true,
		},
		{
			text: 'Codigo',
			key: 'value',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Color',
	plural_model_name_spanish: 'Colores',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}